import React, { useState } from 'react';
import { HiOutlineChatAlt, HiOutlineMail, HiOutlineDeviceMobile } from 'react-icons/hi';
import WhatsAppTemplates from './WhatsAppTemplates';
import EmailTemplates from './EmailTemplates';
import SMSTemplates from './SMSTemplates';

// Template types selectable in one line at the top of the section.
const TEMPLATE_TYPES = [
  { id: 'whatsapp', label: 'WhatsApp Template', icon: HiOutlineChatAlt },
  { id: 'email', label: 'Email Template', icon: HiOutlineMail },
  { id: 'sms', label: 'SMS Template', icon: HiOutlineDeviceMobile },
];

/**
 * Merged Templates section: shows the three template types (WhatsApp,
 * Email, SMS) in a single selectable line; the chosen type's template
 * manager renders below.
 */
const Templates = () => {
  const [selectedType, setSelectedType] = useState('whatsapp');

  const renderTemplateManager = () => {
    switch (selectedType) {
      case 'whatsapp':
        return <WhatsAppTemplates />;
      case 'email':
        return <EmailTemplates />;
      case 'sms':
        return <SMSTemplates />;
      default:
        return <WhatsAppTemplates />;
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* One-line template type selector */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3">
        {TEMPLATE_TYPES.map((type) => {
          const Icon = type.icon;
          const isActive = selectedType === type.id;
          return (
            <button
              key={type.id}
              type="button"
              onClick={() => setSelectedType(type.id)}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl border-2 text-left transition-all duration-200 ${
                isActive
                  ? 'border-primary-500 bg-primary-50 shadow-sm'
                  : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  isActive ? 'bg-primary-100' : 'bg-gray-100'
                }`}
              >
                <Icon className={`w-5 h-5 ${isActive ? 'text-primary-600' : 'text-gray-500'}`} />
              </div>
              <span
                className={`text-sm font-semibold whitespace-nowrap ${
                  isActive ? 'text-primary-700' : 'text-gray-700'
                }`}
              >
                {type.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Selected template manager */}
      {renderTemplateManager()}
    </div>
  );
};

export default Templates;